<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex
          xs12
          mt-3
        >
          <h1 class="headline">{{ $t('driverAutos.title') }} - {{ driverName }}</h1>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular
              :size="70"
              color="warning"
              indeterminate
            />
          </div>
          <v-layout wrap align-center v-if="!dataIsLoading">
            <v-flex xs12 >
              <!-- Error Alert -->
              <alert-error class="px-3 mt-4" />
              <!-- Success Alert-->
              <v-layout
                v-if="successAlert.state"
                id="sucessAlert"
                row
                class="alert-wrapper mt-2 mb-2"
              >
                <v-flex sm12>
                  <v-alert :value="successAlert.state" type="success">
                    {{ successAlert.message }}
                  </v-alert>
                </v-flex>
              </v-layout>
              <!-- Add Auto -->
              <div class="title mb-4">{{ $t('driverAutos.availableAutos') }}</div>
              <driver-add-auto class="mb-4" />
              <!-- Driver Autos List -->
              <driver-autos />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- Delete Driver Auto Dialog -->
      <delete-driver-auto-dialog />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import AlertError from '@/components/shared/AlertError.vue';
import DriverAddAuto from '@/components/driver/DriverAddAuto.vue';
import DriverAutos from '@/components/driver/DriverAutos.vue';
import DeleteDriverAutoDialog from '@/components/driver/DeleteDriverAutoDialog.vue';

export default {
  name: 'DriverAutosPage',
  components: {
    DriverAddAuto,
    DriverAutos,
    DeleteDriverAutoDialog,
    AlertError,
  },
  data() {
    return {
      dataIsLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      driverName: 'driver/getDriverName',
      driverAutos: 'driver/getDriverAutos',
      successAlert: 'global/getAlertSuccess',
    }),
  },
  async created() {
    this.dataIsLoading = true;
    try {
      await this.fetchDriverAutos(
        {
          id: this.$route.params.driverId,
        },
      );
      this.dataIsLoading = false;
    } catch (error) {
      if (error.status === 404) {
        this.$router.push({ name: 'not-found' });
        return;
      }
      this.dataIsLoading = false;
    }
  },
  destroyed() {
    this.clearAlertError();
    this.clearAlertSuccess();
    this.setDriverAutos([]);
    this.setDriverAvailableAutos([]);
  },
  methods: {
    ...mapActions({
      fetchDriverAutos: 'driver/fetchDriverAutos',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setDriverAutos: 'driver/setDriverAutos',
      setDriverAvailableAutos: 'driver/setDriverAvailableAutos',
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
